import {
  convertBase64ToBlob,
  convertBlobToBase64,
} from 'apps/easyForm/lib/utils/pdfData'
import { getOperationType } from 'apps/builder/lib/utils'
import { convertToBuilderType } from 'apps/builder/lib/transforms'
import { initialState } from 'apps/easyForm/store/reducers/entities/pdf'

export const extractForm = ({
  entries = [],
  sheets = [],
  sections = [],
  conditions = [],
  operations = [],
  type,
  ...app
}) => {
  const entryGuidToSheetIdMap = new Map()
  const entryIdToEntryGuidMap = new Map()

  const processedEntries = entries.map(entry => {
    entryGuidToSheetIdMap.set(entry.guid, String(entry.sheet_id))
    entryIdToEntryGuidMap.set(entry.id, entry.guid)
    return {
      ...entry,
      type: convertToBuilderType(entry.type, entry.style),
    }
  })

  return {
    app,
    entries: processedEntries,
    sheets,
    sections,
    conditions,
    operations: operations.map(
      ({ value_entry_id, entry: entryGuid, ...operation }) => {
        const valueEntryGuid = value_entry_id
          ? entryIdToEntryGuidMap.get(value_entry_id)
          : null
        return {
          ...operation,
          value_entry_id,
          entry: entryGuid,
          sheet_id: entryGuidToSheetIdMap.get(entryGuid),
          ...(valueEntryGuid && {
            parentEntryGuid: valueEntryGuid,
            parentEntrySheetId: entryGuidToSheetIdMap.get(valueEntryGuid),
          }),
        }
      }
    ),
  }
}

// from api, format=flat
export const extractFlatOperations = operations =>
  operations.map(({ operation_type_id, value_entry, ...operation }, i) => {
    return {
      ...operation,
      operation_type_id,
      operation_type: getOperationType(operation_type_id),
      index: i,
    }
  })

export const extractPdf = pdfData => {
  if (!pdfData || !pdfData.id) return {}

  const { pages, elements, base64, position, ...pdfMetaData } = pdfData

  return {
    pdf: {
      ...initialState,
      position: position ? position : initialState.position,
      ...pdfMetaData,
      pdf_path: convertBase64ToBlob(base64),
    },
    pages,
    elements,
  }
}

export const assemblePdf = async (pdf, pages, layouts, elements) => {
  const { pdf_path, ...pdfMetaData } = pdf
  const response = await fetch(pdf_path)
  const blob = await response.blob()
  const base64String = await convertBlobToBase64(blob)

  return {
    ...pdfMetaData,
    base64: base64String,
    pages,
    layouts,
    elements,
  }
}
